import { http } from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    /**
     * @param {string} username
     * @param {string} password
     *
     * @returns {Promise.<Object>}
     */
    login(username, password) {
        return http.post('/api/login', {
            username: username,
            password: password
        }).then(getData);
    },

    /**
     * @returns {Promise.<Object>}
     */
    logout() {
        return http.post(`/api/logout`).then(getData);
    },

    /**
     * @returns {Promise.<Object>}
     */
    authUser() {
        return http.get('/api/v1/user').then(getData);
    },

    /**
     * @returns {Promise.<Array>}
     */
    userAbilities() {
        return http.get('/api/v1/abilities').then(getData);
    },

    /**
     *
     * @returns {Promise.<Array>}
     */
    projectAbilities() {
        return http.get('/api/v1/project-abilities').then(getData);
    },

    /**
     * @returns {Promise.<Object>}
     */
    userSettings() {
        return http.get('/api/v1/settings').then(getData);
    },

    /**
     * @returns {Promise.<String>}
     */
    getSystemVersion() {
        return http.get('/api/v1/system-version').then(getData);
    },

    getSystemLocale() {
        return http.get(`/api/system-locale`).then(getData);
    }

};



// WEBPACK FOOTER //
// ./src/services/Auth/AuthenticationController.js